
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamond-payout/manage-donation",
      function () {
        return require("private-next-pages/diamond-payout/manage-donation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diamond-payout/manage-donation"])
      });
    }
  